import React, { Component } from 'react';
import ReactTable from "react-table";
import couterpart from 'counterpart';
import {MdDeleteForever, MdOpenInNew} from 'react-icons/md';

import "react-table/react-table.css";
import '../css/style.css';

// import ReactTablePagination from './PaginationComponent';
import ItemDataService from '../services/ItemDataService';
import AuthenticationService from '../services/AuthenticationService';
import { ICON_COLOR } from '../icon';


class ItemImageViewer extends Component {
  constructor (props) {
    super(props);
    
    this.state = {
      images: [],
      columns : [
        {
          Header: couterpart.translate('name'),
          accessor: 'name',
          filterable: false,
          Cell: props => props.value
        },        
        {
            Header: `${this.props.caption}`,
            Cell: row =>(
                <div>
                  <table width="100%" border="0" cellPadding="0">
                    <tbody>
                      <tr>
                        <td width="80%"><img alt="" 
                        src={`data:image/jpeg;base64,${row.original.content}`} style={{ cursor: "pointer" }}
                        width={225} height={225} onClick={() => this.downloadImage(row.original.id, row.original.contentType)}/></td>
                        <td>
                        {this.renderButtons(row)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            )
      }]
    };
  }

  renderButtons(row){
    const button_view = couterpart.translate('button_view');
    if (AuthenticationService.isAdmin() || 
      AuthenticationService.isService()){
        const button_delete = couterpart.translate('button_delete');
        const isEdit = this.props.mode === "MODE_EDIT";
        return(
        <div>
          {/* <button className="myButton" onClick={() => this.downloadImage(row.original.id, row.original.contentType)}>
            <MdOpenInNew color={ICON_COLOR}/> &nbsp;
            {button_view}</button>&nbsp;&nbsp; */}
          {isEdit && <button className="myButton" onClick={() => this.deleteImage(row.original.id)}>
            <MdDeleteForever color={ICON_COLOR}/>&nbsp;
            {button_delete}</button>}
        </div>
        );
    // }else if (AuthenticationService.isDesigner()){
    //   return(<div>
    //   <button className="myButton" onClick={() => this.downloadImage(row.original.id, row.original.contentType)}>
    //   <MdOpenInNew color={ICON_COLOR}/>&nbsp;
    //   {button_view}</button>
    //   </div>);
    }else{
      return (<div>&nbsp;</div>);
    }
  }

  downloadImage(imageId, contentType){
    ItemDataService.downloadImage(imageId, contentType);
  }

  deleteImage(imageId){
    ItemDataService.deleteImage(imageId).then(data => {
      this.props.handleUpdate(null);
    });
  }

  render() {

    return (
          <div className="row">
            <div className="col-12">
              <label>{this.props.isUpdated}</label>
              <ReactTable
                NoDataComponent={() => null} 
                previousText={"<"}
                nextText={">"}
                data={this.props.images}
                columns={this.state.columns}
                defaultPageSize = {5}
                showPageSizeOptions = {true}
                pageSizeOptions = {[2, 5, 10, 20]}
                showPagination={true}
              />
          </div>
        </div>    
    )
  }
}

export default ItemImageViewer;